import axios from "axios";
// import store from "@/store"; // Import Vuex store
// import router from "@/router"; // Pastikan konfigurasi router sudah benar

// Buat instance axios
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // Ganti dengan URL API Anda
});

// Tambahkan interceptor untuk body json
apiClient.interceptors.request.use(
  (config) => {
    if (config.data instanceof FormData) {
      // Jangan set Content-Type ketika mengirimkan FormData, biarkan browser menanganinya
      delete config.headers["Content-Type"];
    } else {
      config.headers["Content-Type"] = "application/json"; // Default untuk JSON
    }
    return config;
  },
  (error) => {
    // Tangani error request
    // store.dispatch("hideLoading");
    return Promise.reject(error);
  }
);

// Export default axios instance
export default apiClient;
